// removed by extract-text-webpack-plugin
module.exports = {"svg":"NdgZZSpMCLV7Gev3dBghE_0","stroke":"_3hHZaAHFH8I0njJc18bBYF_0","fill":"_2gL_wCHqO8sx1IIq4xxf3Z_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b9506450","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SvgIcon.vue
// module id = v/Xa
// module chunks = 1